import type { JobNumberItem } from '../types';

// 仕事Noは大文字小文字を区別して登録されるため、重複判定も区別して行う。
export const isDuplicateCommittedJobNumber = (rows: JobNumberItem[], excludeId: string, jobNumber: string): boolean =>
  rows.some(row => row.id !== excludeId && row.status === 'committed' && row.jobNumber === jobNumber);
